<template>
  <ul class="bottom-board-items" :class="item?.reqStats ?? ''">
    <li>
      <label v-if="type == 'add'"> ({{ step + 1 }}단계) 코인가격</label>
      <label v-else-if="type == 'sellf'"> 손절 코인가격</label>
      <label v-else-if="type == 'sellp'"> 익절 코인가격</label>
      <label v-else>코인가격</label>
      <p>
        {{ parseTriggerPrice(item) }}
        <small>USDT</small>
      </p>
    </li>
    <li v-if="type !== 'sellf' && type !== 'sellp'">
      <label>코인수량</label>
      <p>
        {{ item?.symbolSize }}
        <small>{{ curCoinName }}</small>
      </p>
    </li>
    <li v-if="type !== 'sellf' && type !== 'sellp'">
      <label>사용/예정 USDT</label>
      <p>{{ parseNumberFloorUSDT(item?.usdtAmt) }} <small>USDT</small></p>
    </li>
    <li>
      <label>상태</label>
      <p>
        {{
          parseReqStateAndError(item?.reqStats, item?.execMsg, retryForceMin)
        }}
      </p>
    </li>
    <li v-if="type === 'init' && item?.reqStats === 'DELAY'">
      <p>
        <button
          type="button"
          @click="forceUndelayTrade"
          class="bg-orange-400 px-2 py-1 rounded-sm text-white"
        >
          재진입 실행 <i class="icon-play"></i>
        </button>
      </p>
    </li>
  </ul>
</template>
<script>
import { storeName } from "@/global/variable";
import { mapActions } from "vuex";

export default {
  name: "BottomCard",
  props: {
    item: Object,
    type: String,
    step: Number,
    retryForceMin: Number,
    symbolConfig: Object,
    curCoinName: String,
  },
  methods: {
    ...mapActions(storeName.buyConfig, ["AT_TRADE_DELAY_FORCE"]),
    parseTriggerPrice(item) {
      if (item === null) return "-";
      return item?.itemType === "INIT"
        ? this.parsePriceFloorUSDT(item.symbolBinancePrice)
        : this.parsePriceFloorUSDT(item.triggerPrice);
    },
    parseReqStateAndError(reqStats, execMsg, interval) {
      let colName;
      switch (reqStats) {
        case "READY":
          colName = "주문대기";
          break;
        case "PENDING":
          colName = "요청중";
          break;
        case "SUCCESS":
          colName = "처리완료";
          break;
        case "FAILED":
          colName = this.parseErrorMsg(execMsg);
          break;
        case "PARITAL":
          colName = "부분 체결";
          break;
        case "CANCELED":
          colName = "거래 취소";
          break;
        case "DELAY":
          colName = `재진입 대기 (${interval} 분)`;
          break;
      }
      // console.log(execMsg);
      return colName;
    },
    parseErrorMsg(execMsg) {
      let errorMsg;
      switch (execMsg) {
        case "OVER_USDT":
          errorMsg = "자산 상한 초과";
          break;
        case "COUNTERPARTY":
          errorMsg = "유동 금액 불충분";
          break;
        case "NOT_ENOUGH":
          errorMsg = "잔고 부족";
          break;
        case "Margin is insufficient.":
          errorMsg = "증거금 불충분";
          break;
        case "QUANTITY_ZERO":
          errorMsg = "코인 수량 조건 미달";
          break;
        default:
          errorMsg = "오류";
          break;
      }
      return errorMsg;
    },
    parsePriceFloorUSDT(usdt) {
      let convert;
      if (this.symbolConfig != null) {
        const limit = this.symbolConfig.pricePrecision;
        if (this.symbolConfig != null && limit != null) {
          return Math.floor(usdt * Math.pow(10, limit)) / Math.pow(10, limit);
        } else {
          convert = usdt;
        }
      }
      return convert;
    },
    parseNumberFloorUSDT(usdt) {
      let convert;
      if (this.symbolConfig != null) {
        const limit = this.symbolConfig.quantityPrecision;
        if (this.symbolConfig != null && limit != null) {
          return Math.floor(usdt * Math.pow(10, limit)) / Math.pow(10, limit);
        } else {
          convert = usdt;
        }
      }

      return convert;
    },

    /**
     * 강제 거래 시작 (인터벌 무시 )
     * @param tradeId
     */
    async forceUndelayTrade() {
      if (!confirm("강제로 재진입을 실행하시겠습니까?")) return;
      if (this.item?.tradeItemId == null) {
        alert(
          "올바르지 않은 접근입니다. 새로고침 후 다시 시도해주시기 바랍니다."
        );
      } else {
        this.AT_TRADE_DELAY_FORCE(this.item?.tradeItemId);
      }
    },
  },
};
</script>
